<template>
    <div ref="scrollCFResurseUmane" class="tables-header">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="21. Resurse umane implicate"></CFTitle>
        <div style="display: flex">
            <!--            <v-select-->
            <!--                v-model="selectedJob"-->
            <!--                class="w-96"-->
            <!--                dir="ltr"-->
            <!--                :options="defaultJobs"-->
            <!--                label="name"-->
            <!--                input-id="id_series"-->
            <!--                :clearable="false"-->
            <!--                :class="completed ? 'disabled-select' : '' "-->
            <!--                @input="addJob(selectedJob)"-->
            <!--            >-->
            <!--            </v-select>-->
            <div class="add-button-up mb-3 mt-3" style="margin-right: 20px; margin-left: auto;" @click="setDefaultJobs()">
                <p>Adaugă joburile recomandate</p>
                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
            </div>
            <a class="add-button mb-3 mt-3" :class="{'button-absolute' : checkScroll}" @click="addJob()">
                <p>Adaugă post nou</p>
                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
            </a>
        </div>
        <validation-observer #default="{ invalid }" ref="jobsValidate">
            <span class="display-none">{{ invalid }}</span>
            <table v-for="(job, key) in jobs" :key="key">
                <thead>
                    <tr>
                        <th colspan="2" class="table-head blue-head">
                            <div style="display: flex; align-items: center">
                                <div style="display: flex; width: 100%; align-items: center">
                                    <span class="jobTitle">CERINȚE FIȘA POSTULUI - </span>
                                    <b-form-input
                                        v-model="job.title"
                                        placeholder="Funcție ocupată - Cod COR"
                                        type="text"
                                        :readonly="completed"
                                        style="width: 70%"
                                    >
                                    </b-form-input>
                                </div>
                                <b-icon-x-circle-fill v-if="key > 0" class="delete-icon" font-scale="1.1" @click="deleteJob(key)"></b-icon-x-circle-fill>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="2" class="table-head">
                            <p>EDUCAȚIE</p>
                            <b-icon-plus-circle-fill class="add-icon" font-scale="1.1" @click="addEducation(key)"></b-icon-plus-circle-fill>
                        </td>
                    </tr>
                </tbody>
                <tbody v-for="(item, keyEducation) in job.education" :key="keyEducation" class="grouped-education" :style="keyEducation === job.education.length-1 ? {borderBottom: '0'} : ''">
                    <tr>
                        <td colspan="2" style="position: relative;">
                            <p style="text-align: center; font-weight: 600">Educație {{ keyEducation+1 }}</p>
                            <b-icon-x-circle-fill v-if="keyEducation > 0" class="delete-icon" font-scale="1.1" @click="deleteEducation(key, keyEducation)"></b-icon-x-circle-fill>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Descriere</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="item.desc"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Durata solicitată</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="item.period"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                </tbody>
                <tbody>
                    <tr>
                        <td colspan="2" class="table-head"><p>EXPERIENȚĂ</p></td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Descriere</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.experience.desc"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Durata solicitată</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.experience.period"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="table-head">
                            <p>COMPETENȚE</p>
                            <b-icon-plus-circle-fill class="add-icon" font-scale="1.2" @click="addAuthority(key)"></b-icon-plus-circle-fill>
                        </td>
                    </tr>
                    <tr v-for="(competenta, keyAuthority) in job.authority" :key="keyAuthority">
                        <td style="width: 17%; position: relative;">
                            <p>Descriere</p>
                            <b-icon-x-circle-fill v-if="keyAuthority > 0" class="delete-icon" font-scale="1.1" @click="deleteAuthority(key, keyAuthority)"></b-icon-x-circle-fill>
                        </td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="competenta.desc"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="table-head"><p>LIMBI STRĂINE SOLICITATE</p></td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Limba 1</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.languages.language"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p><i>Înțelegere</i></p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.languages.understanding"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p><i>Vorbire</i></p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.languages.talking"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p><i>Scriere</i></p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.languages.writing"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="table-head gray-head"><p>CURRICULUM VITAE</p></td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Externalizat</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.outsourced"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Angajat de</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.employed_by"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Prenume și nume</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.full_name"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Data nașterii</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.birth_date"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Cetățenie</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.citizenship"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Telefon</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.phone"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Fax</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.fax"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 17%"><p>Email</p></td>
                        <td>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="job.curriculum.email"
                                    type="text"
                                    :readonly="completed"
                                    :state="errors.length > 0 ? false : null"
                                >
                                </b-form-input>
                            </validation-provider>
                        </td>
                    </tr>
                </tbody>
            </table>
        </validation-observer>
        <hr class="mt-5">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
        <p id="scrollAuxiliary" style="display: none; margin-top:300px">&nbsp;</p>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import M3Warn from "../M3Warn";
    import vSelect from "vue-select";
    require('@/helpers/validations/validations')
    export default {
        components: {
            BTable,
            CFTitle,
            BFormInput,
            BIconXCircleFill,
            BIconPlusCircleFill,
            BFormCheckbox,
            M3Warn,
            ValidationProvider, ValidationObserver,
            vSelect
        },
        props: {
            m3GrantApplication: {
                type: Object,
                default: null
            },
            data: null,
            checkScroll:{
                type:Boolean,
                default:false
            },
        },
        data() {
            return {
                completed: false,
                selectedJob: null,
                defaultJobs: [],
                jobs: []
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress'];
            },
            savedJobs() {
                return this.m3GrantApplication ? this.m3GrantApplication.resurse_umane : null;
            }
        },
        watch: {
            finantareProgress: {
                handler() {
                    if(this.finantareProgress.includes('Resurse umane implicate'))
                        this.completed = true;
                },
                deep: true
            },
            savedJobs: {
                handler() {
                    if(this.savedJobs)
                        this.jobs = this.savedJobs;
                },
                deep: true
            }

        },
        mounted() {
            if(this.finantareProgress.includes('Resurse umane implicate'))
                this.completed = true;
            if(this.m3GrantApplication && this.m3GrantApplication.resurse_umane){
                let anyChanges = false
                this.m3GrantApplication.resurse_umane.forEach(item => {
                    if(!(item.education instanceof Array)){
                        item.education = [{
                            desc: item.education.desc,
                            period: item.education.period,
                        }]
                        anyChanges = true
                    }
                    if(!(item.authority instanceof Array)){
                        item.authority = [{
                            desc: item.authority.desc,
                        }]
                        anyChanges = true
                    }
                })
                this.jobs = this.m3GrantApplication.resurse_umane
                if(anyChanges) {
                    this.sendForm()
                }
            } else {
                this.setDefaultJobs()
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            addJob(defaultJob = null) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    if(defaultJob){
                        this.jobs.push({
                            title: null,
                            education: [{
                                desc: '',
                                period: '',
                            }],
                            experience: {
                                desc: '',
                                period: '',
                            },
                            authority: [{
                                desc: '',
                            }],
                            languages: {
                                language: '',
                                understanding: '',
                                talking: '',
                                writing: '',
                            },
                            curriculum: {
                                outsourced: '',
                                employed_by: '',
                                full_name: '',
                                birth_date: '',
                                citizenship: '',
                                phone: '',
                                fax: '',
                                email: '',
                            }
                        })
                    }
                    else {
                        this.jobs.push({
                            title: null,
                            education: [{
                                desc: '',
                                period: '',
                            }],
                            experience: {
                                desc: '',
                                period: '',
                            },
                            authority: [{
                                desc: '',
                            }],
                            languages: {
                                language: '',
                                understanding: '',
                                talking: '',
                                writing: '',
                            },
                            curriculum: {
                                outsourced: '',
                                employed_by: '',
                                full_name: '',
                                birth_date: '',
                                citizenship: '',
                                phone: '',
                                fax: '',
                                email: '',
                            }
                        })
                    }
                    document.getElementById('scrollAuxiliary').style.display = 'block';
                    this.$refs.scrollCFResurseUmane.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
                    document.getElementById('scrollAuxiliary').style.display = 'none';
                }
            },
            deleteJob(key){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.jobs.splice(key, 1)
                }
            },
            deleteEducation(key, key2){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.jobs[key].education.splice(key2, 1)
                }
            },
            addEducation(key) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.jobs[key].education.push({
                        desc: '',
                        period: '',
                    })
                }
            },
            deleteAuthority(key, key2){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.jobs[key].authority.splice(key2, 1)
                }
            },
            addAuthority(key) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.jobs[key].authority.push({
                        desc: '',
                    })
                }
            },
            setDefaultJobs() {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    // MANAGER DE PROIECT
                    this.jobs.push({
                        title: 'Manager proiect - COD COR 242101',
                        education: [{
                            desc: 'Studii superioare',
                            period: '3 ani',
                        },{
                            desc: 'Curs de specializare Manager de proiect',
                            period: '-',
                        },],
                        experience: {
                            desc: 'Management',
                            period: '0-5 ani',
                        },
                        authority: [
                            {
                                desc: 'cunoștințe de operare pe calculator (MS Office, Excel,Word, Power Point etc.)',
                            },
                            {
                                desc: 'gândire analitică și sintetică',
                            },
                            {
                                desc: 'capacitate de decizie și de rezolvare a problemelor cu nivel înalt de dificultate',
                            },
                            {
                                desc: 'spirit de organizare dezvoltat',
                            },
                            {
                                desc: 'capacitate de comunicare scrisă şi verbală',
                            },
                            {
                                desc: 'abilităţi pentru munca în condiții de stres, în situaţii de urgenţă sau neprevăzute.',
                            },
                        ],
                        languages: {
                            language: 'Engleză',
                            understanding: 'Mediu',
                            talking: 'Mediu',
                            writing: 'Mediu',
                        },
                        curriculum: {
                            outsourced: '',
                            employed_by: '',
                            full_name: '',
                            birth_date: '',
                            citizenship: '',
                            phone: '',
                            fax: '',
                            email: '',
                        }
                    })

                    // RESPONSABIL CU PROTECTIA DATELOR
                    this.jobs.push({
                        title: 'Responsabil cu protecția datelor cu caracter personal - COD COR 242231',
                        education: [{
                            desc: 'Studii superioare',
                            period: '3 ani',
                        },{
                            desc: 'Curs de inițiere/perfecționare/specializare Responsabil cu protecția datelor cu caracter personal',
                            period: '-',
                        },],
                        experience: {
                            desc: 'Experiență relevantă în managementul protecției datelor cu caracter personal, proporțională cu sensibilitatea, complexitatea și volumul de date cu caracter personal pe care angajatorul le prelucrează',
                            period: '0-5 ani',
                        },
                        authority: [
                            {
                                desc: 'Cunoștințe de specialitate în domeniul protecției datelor cu caracter personal și o înțelegere aprofundată a Regulamentului (UE) nr. 2016/679',
                            },
                            {
                                desc: 'Integritate și etică profesională ridicată',
                            },
                            {
                                desc: 'Abilitatea de a respecta secretul sau confidențialitatea în ceea ce privește îndeplinirea sarcinilor sale',
                            },
                            {
                                desc: 'Abilitatea de a comunica eficient cu cele mai înalte niveluri ale conducerii',
                            },
                            {
                                desc: 'Abilitatea de a participa la elaborarea evaluărilor de impact asupra protecției datelor cu caracter personal, de a înțelege și evalua în mod adecvat riscurile',
                            },
                            {
                                desc: 'Intelegerea tehnologiei informației și a comunicațiilor, precum și practica și auditurile în materia securității informației',
                            },
                            {
                                desc: 'Abilitatea de a comunica în mod eficient cu persoanele vizate, cu Autoritățile de supraveghere, cu alți operatori, cu persoanele împuternicite, inclusiv la nivel internațional',
                            },
                            {
                                desc: 'Intelegerea adecvată a operațiunilor de prelucrare, a sistemelor informatice și a cerințelor în materie de securitate și protecție a datelor cu caracter personal',
                            },
                            {
                                desc: 'Abilitatea de a lua decizii și de a acționa independent',
                            },
                        ],
                        languages: {
                            language: 'Engleză',
                            understanding: 'Mediu',
                            talking: 'Mediu',
                            writing: 'Mediu',
                        },
                        curriculum: {
                            outsourced: '',
                            employed_by: '',
                            full_name: '',
                            birth_date: '',
                            citizenship: '',
                            phone: '',
                            fax: '',
                            email: '',
                        }
                    })

                    // RESPONSABIL FINANCIAR
                    this.jobs.push({
                        title: 'Responsabil financiar',
                        education: [{
                            desc: 'Studii superioare în domeniu',
                            period: '3 ani',
                        },{
                            desc: 'Curs de inițiere/perfecționare/specializare Responsabil cu protecția datelor cu caracter personal',
                            period: '-',
                        },],
                        experience: {
                            desc: 'Experiență relevantă în domeniul financiar',
                            period: '0-5 ani',
                        },
                        authority: [
                            {
                                desc: 'cunoștințe de operare pe calculator (MS Office, Excel,Word, Power Point etc.)',
                            },
                            {
                                desc: 'gândire analitică și sintetică',
                            },
                            {
                                desc: 'capacitate de decizie și de rezolvare a problemelor cu nivel înalt de dificultate',
                            },
                            {
                                desc: 'spirit de organizare dezvoltat',
                            },
                            {
                                desc: 'capacitate de comunicare scrisă şi verbală',
                            },
                            {
                                desc: 'abilităţi pentru munca în condiții de stres, în situaţii de urgenţă sau neprevăzute',
                            },
                        ],
                        languages: {
                            language: 'Engleză',
                            understanding: 'Mediu',
                            talking: 'Mediu',
                            writing: 'Mediu',
                        },
                        curriculum: {
                            outsourced: '',
                            employed_by: '',
                            full_name: '',
                            birth_date: '',
                            citizenship: '',
                            phone: '',
                            fax: '',
                            email: '',
                        }
                    })
                }
            },
            sendForm() {
                this.$refs.jobsValidate.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {resurse_umane: this.jobs})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Resurse umane implicate')
                                })
                        }
                        else{
                            this.$store.dispatch('finantare/removeFromProgress', 'Resurse umane implicate')
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
.jobTitle{
    width: 25%;
    padding-left: 10%;
}
@media (max-width: 1300px){
    .jobTitle{
        padding-left: 0;
    }
}
table, th, td {
    border: 1px solid #979696;
    width: 100%;
    height: 100%;
}
table{
    margin-top: 25px;
}
.table-head p{
    font-size: 14px;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
}
.table-head{
    padding: 10px;
    border: 1px solid #979696;
    border-bottom: 0;
    position: relative;
}
.blue-head{
    background: #bdd6ee;
}
.gray-head{
    background: #d5dce4;
}
table p{
    font-size: 12px;
    padding: 5px;
}
.smaller-width{
    width: 15%;
}
table >>> input{
    font-size: 12px;
    border: none;
    background: #e9ecef;
}
table >>> input:read-only{
    background: #a1fff1;
}
.delete-icon{
    position: absolute;
    top: 0;
    right: 15px;
    color: var(--dangerColor);
    cursor: pointer;
    bottom: 0;
    margin: auto 0;
}
.add-icon{
    position: absolute;
    top: 0;
    right: 15px;
    color: var(--succesColor);
    cursor: pointer;
    bottom: 0;
    margin: auto 0;
}
.button-absolute{
    position: absolute;
    top: 14px;
    right: 46px;
    z-index:3;
}
.add-button-up{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
    background: #49cda8;
    width: 100%;
    padding: 7px 10px;
    height: 100%;
    max-width: 270px;
    max-height: 40px;
    border-radius: 3px;
    text-transform: none;
}
.add-button-up svg{
    max-height: 22px;
    color: #fff;
    font-weight: 900;
}
.add-button-up p{
    color: #fff;
    text-transform: none;
    font-size: 13px;
    margin: 0;
}
.grouped-education{
    border-bottom: 2px solid var(--mainColorText);
}
</style>
